import { I01TEMPATT_State } from '@batical/types/src'

const I01TEMPATT: I01TEMPATT_State = {
  bati_version: 1,
  deleted: 0,
  name: '',
  saveDate: 0,
  tube_uuid: 'C51126FF-AF0D-4215-B863-C2F08238D2AF',
  in_longConduit: 20,
  in_debitPuisage: 5,
  res_volEauFroid: 0.0,
  res_tpsAttenteEauChaude: 0.0,
  mode: 'none',
  calcul_code: 'I01TEMPATT'
}

export default I01TEMPATT
